// extracted by mini-css-extract-plugin
export default {"container":"styles_container__TQ0Ag","ttl":"styles_ttl__STq-a","txt":"styles_txt__w6PuD"};